<style lang="scss">
li.tab-pane {
  list-style: none;
  width: inherit;
}
</style>

<template>
  <li class="tab-pane" v-show="isShow">
    <slot></slot>
  </li>
</template>

<script>
import { TabEventBus } from './EventBus'

export default {
  name: 'TabPane',
  props: {
    name: { type: String }
  },
  data() {
    return {
      isShow: false
    }
  }
}
</script>
